export enum ContentType {
  Event = 'Event',
  Insights = 'Insights',
  Help = 'Help',
  None = 'None',
}
